import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@app/services/user/user.service';
import { IntegrationService } from '@core/services/integrations/integration.service';
import { UnsubscriberBase } from '@core/services/unsubscriber.base';
import { AppRouteHelper } from '@shared/helpers/app-route.helper';
import { takeUntil } from 'rxjs/operators';

interface ISlackParams {
	code: string;
	state: string;
}

@Component({
	selector: 'app-slack',
	templateUrl: './slack.component.html',
	styleUrls: ['./slack.component.scss'],
})
export class SlackComponent extends UnsubscriberBase implements OnInit {
	private readonly _state = 'cv_slack_integration';
	private readonly redirectUrl = `/${AppRouteHelper.notificationManagement}`;
	private _params: ISlackParams;
	public showError = false;
	public readonly errorMessage =
		'Something went wrong, we cannot complete your integration with Slack. Please contact us at support@zesty.co';

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private userService: UserService,
		private integrationService: IntegrationService,
	) {
		super();
	}

	ngOnInit(): void {
		const { code, state } = this.route.snapshot.queryParams;
		if (state !== this._state || !code) {
			this.showError = true;
			return;
		}

		this._params = { code, state };
		this.integrateSlack();
	}

	private integrateSlack(): void {
		const redirect_uri = window.location.origin + AppRouteHelper.slackIntegration;

		this.integrationService
			.integrateSlack(this._params.code, this.userService.organizationId, redirect_uri)
			.pipe(takeUntil(this.unsubscribe))
			.subscribe({
				next: (_) => {
					void this.router.navigate([this.redirectUrl]);
				},
				error: (error) => {
					console.error('Error with integration slack: ', error);
					this.showError = true;
				},
			});
	}

	public backToDashboard(): void {
		void this.router.navigate([AppRouteHelper.defaultRoute]);
	}
}
